/**
 * The public queue comes from the leaderboard payload when an admin has turned the
 * event's queue panel on. No payload, or a panel that is off, keeps the boards full width.
 */

export interface BigScreenQueueLane {
  /** 1–6. */
  lane: number;
  bib: string;
  name: string;
}

export interface BigScreenQueueShooter {
  bib: string;
  name: string;
}

export interface BigScreenQueueBatch {
  /** "Batch 1", "Batch 2". The first batch is labelled "Up next". */
  label: string;
  shooters: BigScreenQueueShooter[];
}

export interface BigScreenQueue {
  /** Who is on the lanes now. The approved layout shows six. */
  now: BigScreenQueueLane[];
  nowTeam?: string | null;
  upcoming: BigScreenQueueBatch[];
}

/** Null hides the panel. The layout already reserves a third column when this returns a queue. */
export function loadBigScreenQueue(queue?: BigScreenQueue | null): BigScreenQueue | null {
  return queue ?? null;
}
